<template>
  <Modal
    directional
    size="small"
    @close="$emit('close')"
    :title="$t(`campaignDesigner.targetDefinition.manageZipCodes.label`)">

    <Card additional-classes="slds-card_boundary" has-empty-title>
      <template v-if="editable">
        <div class="slds-button-group" role="group" slot="actions">
          <FilePicker accept="text/csv" :label="$t('action.upload')" @load="handleUpload" />
          <button class="slds-button slds-button_neutral" @click="downloadTemplate">{{$t('campaignDesigner.targetDefinition.downloadTemplate')}}</button>
        </div>

        <template v-for="market in Object.keys(localValue)">
          <IncludedFilter
            :items-validation="getItemsValidation(market)"
            :label="$t(`markets.${market}`)"
            :key="market"
            input-type="text"
            ref="child"
            v-if="editable"
            v-model="localValue[market]" />
        </template>
      </template>

      <template v-else>
        <Card
          :title="$t(`markets.${market}`)"
          :key="market"
          additional-classes="slds-card_boundary"
          v-for="market in Object.keys(localValue)">

          <OutputField :value="localValue[market]" type="array" />

        </Card>
      </template>
    </Card>

    <template slot="footer" v-if="editable">
      <button class="slds-button slds-button_neutral" @click="$emit('close')">{{$t('action.cancel')}}</button>
      <button class="slds-button slds-button_brand" @click="save">{{$t('action.save')}}</button>
    </template>
  </Modal>
</template>
<script>
import _ from 'lodash'
import Card from '../../../slds/Card'
import FilePicker from '../../../slds/FilePicker'
import OutputField from '../../../slds/OutputField'
import IncludedFilter from './../../filters/IncludedFilter.vue'
import Modal from '../../../Modal'
import { exportTemplateAsCSV as createCsv } from '../../../utils/fileUtils'
import { toggleInArray } from '../../../utils/utils'

export default {
  watch: {
    value (value) {
      this.localValue = _.cloneDeep(value)
    }
  },
  created () {
    this.localValue = _.cloneDeep(this.value)
    this.zipCodeRegexByMarket = this.$store.getters['settings/settings'].zipCodeRegex
  },
  data () {
    return {
      localValue: {},
      zipCodeRegexByMarket: {}
    }
  },
  methods: {
    save () {
      this.$emit('input', _.cloneDeep(this.localValue))
      this.$emit('close')
    },
    getItemsValidation (market) {
      const regex = this.zipCodeRegexByMarket[market]
      return [{
        message: this.$t('validation.custom.invalidZipCodeForMarket'),
        name: 'regex',
        regex: new RegExp(regex)
      }]
    },
    handleUpload (event) {
      const markets = Object.keys(this.localValue)
      const { content } = event

      try {
        const rows = content.split(/\r?\n/)
        const invalidZipCodes = []
        rows.forEach(row => {
          if (row) {
            const [ market, zipCode ] = row.split(',')
            // Check if zip code matches market's regex
            if (markets.includes(market)) {
              const re = new RegExp(this.zipCodeRegexByMarket[market])
              if (re.test(zipCode)) {
                this.localValue[market].push(zipCode)
              } else {
                invalidZipCodes.push(`<li>- ${market} - ${zipCode}</li>`)
              }
            }
          }
        })

        // Remove duplicates
        Object.keys(this.localValue).forEach(market => {
          this.localValue[market] = Array.from(new Set(this.localValue[market]))
        })

        if (invalidZipCodes.length) {
          this.showToast('warning',
            this.$t('campaignDesigner.targetDefinition.manageZipCodes.invalidZipCodesWarning'),
            'HTML',
            this.$t('campaignDesigner.targetDefinition.manageZipCodes.invalidZipCodesWarningText', { list: invalidZipCodes.join('') }))
        } else {
          this.showToast('success', this.$t('general.success'), 'text', this.$t('message.update'))
        }
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', error)
      }
    },
    removeZipCode (market, zipCode) {
      toggleInArray(this.localValue[market], zipCode)
    },
    downloadTemplate () {
      createCsv(`EMPTY_ZIP_CODES_CSV`, `TEMPLATE_ZIP_CODES.csv`)
    }
  },
  components: {
    Card,
    FilePicker,
    IncludedFilter,
    Modal,
    OutputField
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
      required: false
    },
    value: Object
  }
}
</script>
<style lang="scss" scoped>
  svg {
    cursor: pointer;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;

    & > * {
      &:nth-child(odd) {
        margin-left: 20px;
      }
    }
  }
</style>
